import { useQuery } from "@tanstack/react-query";
import adminApiClient from "../../api/admin";

export const useArtistsClocksCount = () => {
  return useQuery<number>({
    queryKey: ["artistsClocksCount"],
    queryFn: async () => {
      return adminApiClient.getNumberOfArtistsClocks();
    },
  });
};
